import { render, staticRenderFns } from "./DashboardDeMonitoramento.vue?vue&type=template&id=f0ad3ec6"
import script from "./DashboardDeMonitoramento.vue?vue&type=script&lang=js"
export * from "./DashboardDeMonitoramento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports